var select = document.querySelectorAll('.styled-select select'),
	focusClass = 'focus';

Array.prototype.forEach.call(select, function(el, i) {
	var parent = el.parentNode;

	el.addEventListener('focus', function() {

		if (parent.classList) {
			parent.classList.add(focusClass);
		} else {
			parent.className += ' ' + focusClass;
		}
	})

	el.addEventListener('blur', function() {

		if (parent.classList) {
			parent.classList.remove(focusClass);
		} else {
			parent.className = parent.className.replace(new RegExp('(^|\\b)' + focusClass.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
		}
	})
})
